import { render } from "./viewecogeste.vue?vue&type=template&id=bffc1820"
import script from "./viewecogeste.vue?vue&type=script&lang=js"
export * from "./viewecogeste.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__